<template lang="pug">
  .crud(v-shortcuts="[{ shortcut: [ 'c', ], callback: addUser, push: true, focus: true },{ shortcut: [ 'e', ], callback: editShortcut, push: true, focus: true },{ shortcut: [ 'f', ], callback: setFocusSearch, push: true, focus: true },]")
    modal-users(:form='form', :is-add='isModalAdd')
    .container-fluid
      vm-row(vw-w=12 vm-type='flex' vm-justify='space-around')
        vm-col.card-wrapper(vm-w=5)
          img.icon_absolute(src='@/assets/graphic.png',alt='Logo')
          .content-register
            span.title__main {{ $t('strings.report_doctors_paid')}}
            vm-button.button__wrapper(@click="printReport" icon="bar-chart-outline") {{ $t('strings.generate_report') }}
        vm-col.card-wrapper(vm-w=5)
          img.icon_absolute.op-5(src='@/assets/inversion.png',alt='Logo')
          .content-register
            span.title__main {{ $t('strings.report_profits')}}
            vm-date-picker.filter(type="daterange" :label="$t('strings.range_dates')" :placeholder="$t('strings.select_date')" @on-change="handleChange" :value="filters.betweenDates.created_at")
            vm-button.button__wrapper(@click="printReportProfits" icon="bar-chart-outline") {{ $t('strings.generate_report') }}
</template>

<script>
import ModalUsers from '@/components/modals/ModalUsers.vue'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Reports')

export default {
  name: 'Reports',
  components: {
    ModalUsers
  },
  data: () => ({
    currentPage: 1,
    isModalAdd: true,
    form: {},
    selected: [],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        name: '',
        email: '',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    filters2: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        name: '',
        email: '',
        status: 'completed',
        param: ''
      },
      whereIn: {
        // Agrega las columnas que se filtraran con mas de una opcion ejemplo: status: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        created_at: []
      },
      orderBy: ''
    },
    filtersClear: {}
  }),
  computed: {
    ...mapGetters([
      'report',
      'usersCatalog',
      'paginationReport',
      'filterParams'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, ${t.$t('users.' + column)}` : `${str} ${t.$t('users.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.user'), columns: concatColumns, column: this.$t('users.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0 && this.selected.every(el => el.deleted_at)
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getUsers(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getUsers(this.currentPage)
    }
  },
  async created () {
    this.filtersClear = parseVuexObject(this.filters)
    this.applyFilter(this.filters)
  },
  methods: {
    ...mapActions([
      'deleteUser',
      'deleteUsers',
      'loadReport',
      'loadCatalog',
      'actionUser',
      'setModalVisible',
      'printReportProfits',
      'printReport',
      'applyFilter',
      'clearFilter'
    ]),
    handleChange (date) {
      this.filters.betweenDates.created_at = date
      this.applyFilter(this.filters)
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  }
}
</script>

<style lang="scss">
.container-fluid {
  padding: 40px 40px;
  .card-wrapper {
    position: relative;
    overflow: hidden;
    padding: 20px;
    background-color: #2BA5C6;
    border-radius: 0.5em;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3);
    -moz-box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3);
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3);
  }
}
.icon_absolute {
  width: 200px;
  position: absolute;
  right: 20px;
  bottom: 20px;
  opacity: 0.1;
  transition: all 1s ease-in-out;
}
.content-register {
  position: relative;
  overflow: hidden;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .title__main {
    font-size: 1.5rem;
    display: block;
    text-align: center;
    text-transform: capitalize;
    color: #fff;
    font-weight: bold;
  }
  .button__wrapper {
    font-size: 1rem;
    color: #000;
    background-color: #fff !important;
    font-weight: bold;
  }
}

.card-wrapper:hover .icon_absolute {
  transform: scale(1.1);
}

.op-5 {
  opacity: 0.4;
}
</style>
